
import PageLoadedQueue from "../PageLoadedQueue";

class ShowPassword {

    protected element:HTMLElement;
    protected status:boolean = false;
    protected fields:Array<HTMLInputElement> = [];

    constructor(element: HTMLElement) {
        this.element = element;
        this.handlePasswordClick = this.handlePasswordClick.bind(this);

        this.initializeListeners();
    }

    protected initializeListeners() {
        this.fields = Array.from(this.element.closest('.row')?.querySelectorAll<HTMLInputElement>('input') || []);
        this.status = false;
        this.element.addEventListener('click', this.handlePasswordClick);
    }

    protected handlePasswordClick(event:Event) {
        event.preventDefault();

        if (!this.status) {
            this.fields.forEach(field => field.type = 'text');
            this.element.querySelector<HTMLElement>('.showPassword')?.style.setProperty('display', 'none');
            this.element.querySelector<HTMLElement>('.hidePassword')?.style.removeProperty('display');
        } else {
            this.fields.forEach(field => field.type = 'password');
            this.element.querySelector<HTMLElement>('.showPassword')?.style.removeProperty('display');
            this.element.querySelector<HTMLElement>('.hidePassword')?.style.setProperty('display', 'none');
        }

        this.status = !this.status;
        return false;
    }

    static initializedElements:Map<HTMLElement, ShowPassword> = new Map();

    static initialize() {
        ShowPassword.checkElements();
        document.addEventListener('plandent.html.changed', (e) => {
            ShowPassword.checkElements();
        });
    }
    static checkElements() {
        document.querySelectorAll('.show-password').forEach((element: HTMLElement) => {
            if(!ShowPassword.initializedElements.has(element)) {
                ShowPassword.initializedElements.set(element, new ShowPassword(element));
            }
        });
    }
}

PageLoadedQueue.addFunction(ShowPassword.initialize);
